import { clearAllCachedProfiles } from '../usecases/users-usecases';
import { setCookie } from './cookies';

/**
 * Manages the switching of company context (tenant) for accountants.
 */

export const switchCompany = async (ownerUserId: string, targetPath = '/') => {
    // 1. Guardar el nuevo cid (Company ID / Owner User ID)
    localStorage.setItem('cid', ownerUserId);

    // 2. Establecer la cookie de impersonación para que RoleContext la detecte
    setCookie('owner_user_id', ownerUserId, 30);

    // 2. Limpiar claves de tenant: eliminar todas las LS keys excepto las de autenticación
    const authKeys = ['user_uid', 'cid', 'pending_nav_intent'];

    // Recorrer todas las llaves de localStorage y remover las que no son de auth
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
        if (!authKeys.includes(key)) {
            localStorage.removeItem(key);
        }
    });

    // 3. Limpiar cache en memoria de perfiles
    clearAllCachedProfiles();

    // 4. Limpiar cache de Service Worker para evitar servir datos cacheados del contexto anterior
    if ('caches' in window) {
        try {
            const cacheNames = await caches.keys();
            await Promise.all(
                cacheNames.map(cacheName => caches.delete(cacheName))
            );
        } catch (e) {
            console.error('Error clearing service worker cache:', e);
        }
    }

    // 5. Recargar la aplicación para aplicar el nuevo contexto limpiamente
    window.location.href = targetPath;
};
